//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { FamilyInputItem } from './FamilyInputItem';

export class TestFamilyInputItem extends ItemBase {
    StudentIndices: number[] = [];
    ParentIndices: number[] = [];
    FamilyInputItem: FamilyInputItem | null = null;

    constructor(initializer?: Partial<TestFamilyInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TestFamilyInputItem";
}
